//#region src/core/i18n/text/captions.ts
const prefix = "captions.";
const enableText = {
	key: `${prefix}enable`,
	text: "Enable captions"
};
const disableText = {
	key: `${prefix}disable`,
	text: "Disable captions"
};
//#endregion
export { disableText, enableText };
